import { Container, Title, Text, Paper, Stack, ThemeIcon } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export default function AccountCreated() {
  const { t } = useTranslation();

  return (
    <Container size="sm" py="xl">
      <Paper shadow="md" p="xl" radius="md" withBorder>
        <Stack align="center" gap="lg">
          <ThemeIcon size={80} radius="xl" color="green">
            <span style={{ fontSize: 40 }}>✓</span>
          </ThemeIcon>

          <div style={{ textAlign: 'center' }}>
            <Title order={2}>{t('accountCreated.title')}</Title>
            <Text c="dimmed" mt="xs">
              {t('accountCreated.subtitle')}
            </Text>
          </div>

          <Text ta="center">{t('accountCreated.message')}</Text>
        </Stack>
      </Paper>
    </Container>
  );
}
